/* eslint-disable */
import * as Types from '../../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PdfGeneratorSettings_TemplateLetterheadsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PdfGeneratorSettings_TemplateLetterheadsQuery = { organisationPdfGeneratorTemplates: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationPdfGeneratorTemplatesResult', integrationEnabled: boolean, templates: Array<{ __typename: 'PdfGeneratorTemplate', id: string, name: string, letterheadSetting: Types.PdfGeneratorTemplateLetterheadSetting, pdfLetterheadId?: string | null }> }, viewer?: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, pdfLetterheads: Array<{ __typename: 'PdfLetterheadOption', id: string, name: string, isDefault: boolean }> } } | null };


export const PdfGeneratorSettings_TemplateLetterheadsDocument = gql`
    query PdfGeneratorSettings_TemplateLetterheads {
  organisationPdfGeneratorTemplates {
    ... on OrganisationPdfGeneratorTemplatesResult {
      templates {
        id
        name
        letterheadSetting
        pdfLetterheadId
      }
      integrationEnabled
    }
  }
  viewer {
    ... on Viewer {
      id
      organisation {
        id
        pdfLetterheads {
          id
          name
          isDefault
        }
      }
    }
  }
}
    `;

/**
 * __usePdfGeneratorSettings_TemplateLetterheadsQuery__
 *
 * To run a query within a React component, call `usePdfGeneratorSettings_TemplateLetterheadsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfGeneratorSettings_TemplateLetterheadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfGeneratorSettings_TemplateLetterheadsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePdfGeneratorSettings_TemplateLetterheadsQuery(baseOptions?: Apollo.QueryHookOptions<PdfGeneratorSettings_TemplateLetterheadsQuery, PdfGeneratorSettings_TemplateLetterheadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfGeneratorSettings_TemplateLetterheadsQuery, PdfGeneratorSettings_TemplateLetterheadsQueryVariables>(PdfGeneratorSettings_TemplateLetterheadsDocument, options);
      }
export function usePdfGeneratorSettings_TemplateLetterheadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfGeneratorSettings_TemplateLetterheadsQuery, PdfGeneratorSettings_TemplateLetterheadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfGeneratorSettings_TemplateLetterheadsQuery, PdfGeneratorSettings_TemplateLetterheadsQueryVariables>(PdfGeneratorSettings_TemplateLetterheadsDocument, options);
        }
export function usePdfGeneratorSettings_TemplateLetterheadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdfGeneratorSettings_TemplateLetterheadsQuery, PdfGeneratorSettings_TemplateLetterheadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdfGeneratorSettings_TemplateLetterheadsQuery, PdfGeneratorSettings_TemplateLetterheadsQueryVariables>(PdfGeneratorSettings_TemplateLetterheadsDocument, options);
        }
export type PdfGeneratorSettings_TemplateLetterheadsQueryHookResult = ReturnType<typeof usePdfGeneratorSettings_TemplateLetterheadsQuery>;
export type PdfGeneratorSettings_TemplateLetterheadsLazyQueryHookResult = ReturnType<typeof usePdfGeneratorSettings_TemplateLetterheadsLazyQuery>;
export type PdfGeneratorSettings_TemplateLetterheadsSuspenseQueryHookResult = ReturnType<typeof usePdfGeneratorSettings_TemplateLetterheadsSuspenseQuery>;
export type PdfGeneratorSettings_TemplateLetterheadsQueryResult = Apollo.QueryResult<PdfGeneratorSettings_TemplateLetterheadsQuery, PdfGeneratorSettings_TemplateLetterheadsQueryVariables>;